import {Agent, Query, request} from './base';

import {Language} from 'models/language';
import {LocaleStats} from 'models/locale-stats';
import {LocaleHistory} from 'models/locale-history';
import {LanguageSync} from 'models/language-sync';
import {LanguageLocale} from 'models/language-locale';
import {LanguageLocaleKey} from 'models/language-locale-key';
import {LanguageLocaleContent} from 'models/language-locale-content';

export class LanguagesAgent extends Agent<Language> {
    constructor() {
        super(Language, '/languages');
    }

    keys = new Agent(LanguageLocaleKey, '/languages/locales/keys');

    content = new Agent(LanguageLocaleContent, '/languages/locales/content');

    getLocales = async ({motherLangId, targetLangId}: { motherLangId: number; targetLangId: number }) => {
        const res = await request.get('/languages/locales', {motherLangId, targetLangId}) as LanguageLocale[];
        return res.map(el => new LanguageLocale(el));
    };

    getSyncStatus = async (query?: Query) => {
        const res = await request.get('/languages/sync', query) as LanguageSync[];
        return res.map(el => new LanguageSync(el));
    };

    getLocaleStats = (languageId: number) => {
        return request.get(`/locales/stats/languages/${languageId}`) as Promise<LocaleStats>;
    };

    getLocaleHistory = async (contentId: number) => {
        const res = await request.get('/locales/history/languages/' + contentId) as LocaleHistory[];
        return res.map(el => new LocaleHistory(el));
    };

    sync = async () => {
        return request.post('/languages/sync', {});
    };

    setOutdated = async (id: number) => {
        return request.patch(`/languages/locales/content/outdated/${id}`, {});
    };

    setOutdatedAll = async (keyId: number, exceptionId: number) => {
        return request.patch(`/languages/locales/content/outdated/${keyId}/${exceptionId}`, {});
    };
}